import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { Badge, ContentMessage, PageHeader } from 'axway-react-ui';
import ComponentUpdates from './ComponentUpdates';
import ComponentUpgrade from './ComponentUpgrade';

class UpdatesView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.reload = window.location.reload.bind(window.location);
	}

	renderError(message) {
		return (
			<ContentMessage
				title={this.intl.formatMsg('Error retrieving updates')}
				summary={this.intl.formatMsg('Check the logs for more details')}
				detail={message}
				imgClass="gg icon-GG-cross-circle"
				className="sm error container"
				inlineContent
			/>
		);
	}

	renderAllOk() {
		return (
			<ContentMessage
				title={this.intl.formatMsg('Your application is up to date')}
				detail={this.intl.formatMsg('There are no updates to install.')}
				imgClass="gg icon-GG-checkmark-circle"
				className="sm empty container"
				inlineContent
			/>
		);
	}

	renderUpdatesAndUpgrades() {
		const { updates: updateInfo, productName } = this.props;
		const { state, updates, upgrades } = updateInfo;
		const hasUpdates = !updates || !!updates.length;
		const hasUpgrades = !upgrades || !!upgrades.length;

		if (state.status === 'error') {
			return this.renderError(updateInfo.state.message);
		} else if (state.status === 'ok' && !hasUpdates && !hasUpgrades) {
			return this.renderAllOk();
		}
		const description
			= this.intl.formatMsg('Upgrades contain breaking changes that can affect your service, and you should install only after reading the release notes and understanding the upgrade.');

		return (
			<div className="updates-upgrades-list">
				<ComponentUpdates
					key="updates"
					updates={updates}
					refresh={this.reload}
					productName={productName}
				/>
				{
					hasUpgrades && (
						<div>
							<div key="header" className="pg-header">
								<div className="pg-header-section">
									<h1 className="pg-header-title">
										{this.intl.formatMsg('Upgrades')}
										{' '}
										<Badge bsStyle="warning">
											{upgrades.length}
										</Badge>
									</h1>
								</div>
							</div>
							<p>
								{description}
							</p>
						</div>
					)
				}
				{
					upgrades.map((upgrade, i) => (
						<ComponentUpgrade
							key={`upgrade-${i}`}
							upgrade={upgrade}
							hasUpdates={hasUpdates}
							refresh={this.reload}
							productName={productName}
						/>
					))
				}
			</div>
		);
	}

	render() {
		const description
			= this.intl.formatMsg('This page helps you manage updates and upgrades to your API Builder components. There may be other updates available from npm that are not in this list.');

		return (
			<div className="updates-view">
				<PageHeader>
					<PageHeader.Section align="left">
						<PageHeader.Title
							infoPopover={{
								id: 'updates-info',
								description,
								docLink: window.$conf.docUpdatesUrl
							}}
						>
							{this.intl.formatMsg('Updates')}
						</PageHeader.Title>
					</PageHeader.Section>
					<PageHeader.Section align="right" />
				</PageHeader>
				{this.renderUpdatesAndUpgrades()}
			</div>
		);
	}
}

UpdatesView.propTypes = {
	/**
	 * The updates available for the service.
	 */
	updates: PropTypes.object.isRequired,
	/**
	 * The product name.
	 */
	productName: PropTypes.string.isRequired
};

export default injectIntl(UpdatesView);
